<template>
  <div class="house-upload-container">
    <el-dialog
      :title="isViewOnly ? '房源详情' : (isEdit ? '编辑房源' : '上架房源')"
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="handleClose">
      <div class="upload-form">
        <el-form :model="form" :rules="rules" ref="uploadForm" label-width="100px" size="small">
          <el-form-item label="房源名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入内容" maxlength="28" :disabled="isViewOnly">
              <span slot="suffix">{{(form.name || '').length}}/28</span>
            </el-input>
          </el-form-item>

          <el-form-item label="户型" required>
            <div class="house-type-inputs">
              <el-input-number v-model="form.roomNum" :min="1" :max="10" placeholder="室" controls-position="right" :disabled="isViewOnly"></el-input-number>
              <span class="type-label">室</span>
              <el-input-number v-model="form.hallNum" :min="0" :max="10" placeholder="厅" controls-position="right" :disabled="isViewOnly"></el-input-number>
              <span class="type-label">厅</span>
              <el-input-number v-model="form.kitchenNum" :min="0" :max="5" placeholder="厨" controls-position="right" :disabled="isViewOnly"></el-input-number>
              <span class="type-label">厨</span>
              <el-input-number v-model="form.toiletNum" :min="1" :max="5" placeholder="卫" controls-position="right" :disabled="isViewOnly"></el-input-number>
              <span class="type-label">卫</span>
            </div>
          </el-form-item>

          <el-form-item label="面积" prop="area">
            <el-input v-model.number="form.area" placeholder="请输入面积" :disabled="isViewOnly">
              <template slot="append">m²</template>
            </el-input>
          </el-form-item>
          <el-form-item label="房屋状态" prop="status">
            <el-radio-group v-model="form.status" :disabled="isViewOnly">
              <el-radio label="1">在租</el-radio>
              <el-radio label="0">闲置</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="朝向" prop="orientation">
            <el-radio-group v-model="form.orientation" :disabled="isViewOnly">
              <el-radio label="南">南</el-radio>
              <el-radio label="北">北</el-radio>
              <el-radio label="东">东</el-radio>
              <el-radio label="西">西</el-radio>
              <el-radio label="南北">南北</el-radio>
              <el-radio label="东西">东西</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="楼层" prop="floor">
            <el-input v-model="form.floor" placeholder="请输入楼层" :disabled="isViewOnly">
              <template slot="append">层</template>
            </el-input>
          </el-form-item>

          <el-form-item label="价格" prop="price">
            <el-input v-model.number="form.price" placeholder="请输入价格" :disabled="isViewOnly">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>

          <el-form-item label="可租日期" prop="availableDate">
            <el-date-picker
              v-model="form.availableDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              style="width: 100%;"
              :disabled="isViewOnly">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="位置" prop="location">
            <el-input v-model="form.location" placeholder="请选择位置" :disabled="isViewOnly">
              <el-button slot="append" icon="el-icon-location-outline" :disabled="isViewOnly"></el-button>
            </el-input>
          </el-form-item>

          <el-form-item label="所属大学" prop="college">
            <el-input v-model="form.college" placeholder="请输入所属大学" :disabled="isViewOnly"></el-input>
          </el-form-item>

          <el-form-item label="出租类型" prop="rentType">
            <el-radio-group v-model="form.rentType" :disabled="isViewOnly">
              <el-radio label="整租">整租</el-radio>
              <el-radio label="合租">合租</el-radio>
              <el-radio label="不限">不限</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="租期" prop="rentPeriod">
            <el-radio-group v-model="form.rentPeriod" :disabled="isViewOnly">
              <el-radio label="长租">长租</el-radio>
              <el-radio label="短租">短租</el-radio>
              <el-radio label="不限">不限</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="租房无忧" prop="isWorryFree">
            <el-switch v-model="form.isWorryFree" :disabled="isViewOnly"></el-switch>
          </el-form-item>

          <el-form-item label="高亮标签" prop="highlightTags">
            <el-checkbox-group v-model="form.highlightTags" :disabled="isViewOnly">
              <el-checkbox label="isShortRent">可短租</el-checkbox>
              <el-checkbox label="isDomestic">民水电</el-checkbox>
              <el-checkbox label="isPropertyFee">包物业费</el-checkbox>
              <el-checkbox label="isLift">电梯</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="普通标签" prop="normalTags">
            <el-tag
              :key="tag"
              v-for="tag in form.normalTags"
              closable
              :disable-transitions="false"
              @close="handleNormalTagClose(tag)"
              :close-transition="isViewOnly"
              style="margin-right: 10px;">
              {{tag}}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="normalTagInputVisible && !isViewOnly"
              v-model="normalTagInputValue"
              ref="saveTagInput"
              size="mini"
              @keyup.enter.native="handleNormalTagInputConfirm"
              @blur="handleNormalTagInputConfirm"
            >
            </el-input>
            <el-button v-else-if="!isViewOnly" class="button-new-tag" size="small" @click="showNormalTagInput">+ 添加标签</el-button>
          </el-form-item>

          <el-form-item label="联系电话" prop="contactPhone">
            <el-input v-model="form.contactPhone" placeholder="请输入电话" :disabled="isViewOnly"></el-input>
          </el-form-item>

          <el-form-item label="联系企微" prop="weChatWorkImage">
            <div v-if="isViewOnly" class="readonly-image-container">
              <img v-if="form.weChatWorkImage" :src="form.weChatWorkImage" class="avatar">
              <div v-else class="no-image-placeholder">
                <i class="el-icon-picture-outline"></i>
                <p>暂无企微二维码</p>
              </div>
            </div>
            <el-upload
              v-else
              class="avatar-uploader"
              :auto-upload="false"
              :http-request="handleCustomWeChatUpload"
              :show-file-list="false"
              :on-change="handleWeChatWorkImageChange"
              :before-upload="beforeAvatarUpload"
              :disabled="isViewOnly">
              <img v-if="form.weChatWorkImage" :src="form.weChatWorkImage" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div v-if="!isViewOnly" class="upload-tip-small">请上传企微二维码部分，多余部分请裁切后上传</div>
          </el-form-item>

          <el-form-item label="上传视频" prop="video">
            <div v-if="isViewOnly" class="readonly-video-container">
              <video v-if="form.videoUrl" :src="form.videoUrl" class="avatar" controls></video>
              <div v-else class="no-image-placeholder">
                <i class="el-icon-video-camera"></i>
                <p>暂无视频</p>
              </div>
            </div>
            <el-upload
              v-else
              class="avatar-uploader"
              :auto-upload="false"
              :http-request="handleCustomVideoUpload"
              :show-file-list="false"
              :on-change="handleVideoChange"
              :before-upload="beforeVideoUpload"
              :disabled="isViewOnly">
              <video v-if="form.videoUrl" :src="form.videoUrl" class="avatar" controls></video>
              <div v-else class="upload-placeholder">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="upload-text">点击上传视频</div>
              </div>
              <el-progress v-if="videoUploadPercent > 0 && videoUploadPercent < 100" :percentage="videoUploadPercent" class="upload-progress"></el-progress>
            </el-upload>
          </el-form-item>

          <el-form-item label="上传照片" prop="images">
            <div v-if="isViewOnly" class="readonly-images">
              <div v-if="form.imageList.length > 0">
                <div v-for="(image, index) in form.imageList" :key="index" class="image-item">
                  <img :src="image.url" @click="handlePreview(image)" class="preview-image">
                </div>
              </div>
              <div v-else class="no-image-placeholder">
                <i class="el-icon-picture-outline"></i>
                <p>暂无图片</p>
              </div>
            </div>
            <el-upload
              v-else
              class="upload-demo"
              list-type="picture-card"
              :auto-upload="false"
              :http-request="handleCustomUpload"
              :on-change="handleImageChange"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="form.imageList"
              multiple
              :limit="9"
              :disabled="isViewOnly"
              drag >
              <template v-if="!isViewOnly">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">点击上方"选择文件"或将文件拖拽到此处上传</div>
                <div class="el-upload__tip" slot="tip">支持批量上传文件，文件格式不限，最多只能上传9份文件</div>
              </template>
            </el-upload>
          </el-form-item>

          <div class="form-actions" v-if="!isViewOnly">
            <el-button @click="dialogVisible = false">取消上传</el-button>
            <el-button type="primary" @click="handleUpload">{{ isEdit ? '确认编辑' : '上传房源' }}</el-button>
          </div>
          <div class="form-actions" v-else>
            <el-button @click="dialogVisible = false">关闭</el-button>
          </div>
        </el-form>
      </div>

      <el-dialog
        width="800px"
        append-to-body
        :visible.sync="previewVisible">
        <img width="100%" :src="previewImage" alt="">
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { getReq, postRed } from '@/api/axiosFun'

export default {
  name: 'HouseUpload',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isViewOnly: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      previewVisible: false,
      previewImage: '',
      form: {
        id: '',
        name: '',
        roomNum: 1,
        hallNum: 1,
        kitchenNum: 1,
        toiletNum: 1,
        area: '',
        orientation: '南',
        floor: '',
        price: '',
        availableDate: new Date().toISOString().split('T')[0],
        location: '',
        rentType: '整租',
        rentPeriod: '长租',
        isWorryFree: false,
        highlightTags: [],
        normalTags: [],
        contactPhone: '',
        weChatWorkImage: '',
        imageList: [],
        videoUrl: '',
        status: '0',
        college: '',
      },
      normalTagInputVisible: false,
      normalTagInputValue: '',
      videoUploadPercent: 0,
      uploadHeaders: {},
      uploadData: {
        token: ''
      },
      rules: {
        name: [ { required: true, message: '请输入房源名称', trigger: 'blur' } ],
        area: [
          { required: true, message: '请输入面积', trigger: 'blur' },
          { type: 'number', message: '面积必须为数字', trigger: 'blur' }
        ],
        floor: [ { required: true, message: '请输入楼层', trigger: 'blur' } ],
        status:[ { required: true, message: '请选择房屋状态', trigger: 'blur' } ],
        price: [ { required: true, message: '请输入价格', trigger: 'blur' } ],
        availableDate: [ { required: true, message: '请选择可租日期', trigger: 'change' } ],
        location: [ { required: true, message: '请选择位置', trigger: 'blur' } ],
        college: [ { required: true, message: '请输入所属大学', trigger: 'blur' } ],
        contactPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      },
      originalData: {}
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val && (this.isEdit || this.isViewOnly) && this.editData) {
        this.initEditData();
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val);
      if (!val) {
        this.resetForm();
      }
    }
  },
  created() {
    this.uploadData.token = localStorage.getItem('token') || '';
  },
  methods: {
    initEditData() {
      if (!this.editData) return;

      let roomNum = 1, hallNum = 1, kitchenNum = 1, toiletNum = 1;
      if (this.editData.housePattern) {
        const patternMatch = this.editData.housePattern.match(/(\d+)室(\d+)厅(\d+)厨(\d+)卫/);
        if (patternMatch) {
          roomNum = parseInt(patternMatch[1], 10) || 1;
          hallNum = parseInt(patternMatch[2], 10) || 0;
          kitchenNum = parseInt(patternMatch[3], 10) || 0;
          toiletNum = parseInt(patternMatch[4], 10) || 1;
        }
      }

      const highlightTags = [];
      if (this.editData.isShortRent === true || this.editData.isShortRent === 1) highlightTags.push('isShortRent');
      if (this.editData.isDomestic === true || this.editData.isDomestic === 1) highlightTags.push('isDomestic');
      if (this.editData.isPropertyFee === true || this.editData.isPropertyFee === 1) highlightTags.push('isPropertyFee');
      if (this.editData.isLift === true || this.editData.isLift === 1) highlightTags.push('isLift');

      // 备份完整的原始数据，确保编辑时保留所有属性
      this.originalData = { ...this.editData };

      this.form = {
        id: this.editData.id || '',
        name: this.editData.title || '',
        roomNum: roomNum,
        hallNum: hallNum,
        kitchenNum: kitchenNum,
        toiletNum: toiletNum,
        area: this.editData.proportion ? parseFloat(this.editData.proportion.replace('㎡', '')) : '',
        orientation: this.editData.orientation || '南',
        floor: this.editData.floor || '',
        price: this.editData.amount || '',
        availableDate: this.editData.checkTime || '',
        location: this.editData.address || '',
        rentType: this.editData.type || '整租',
        rentPeriod: this.editData.leaseTerm || '长租',
        isWorryFree: this.editData.enableType,
        highlightTags: highlightTags,
        normalTags: this.editData.normalTags || [],
        contactPhone: this.editData.phoneNumber || '',
        weChatWorkImage: this.editData.weChatWorkImage || '',
        imageList: [],
        videoUrl: this.editData.videoUrl || '',
        status: this.editData.status !== undefined ? String(this.editData.status) : '0',
        college: this.editData.college || '',
      };

      if (this.editData.imageUrl && this.editData.imageUrl.length) {
        this.form.imageList = this.editData.imageUrl.map((url, index) => {
          if (typeof url === 'string' && url.length > 0) {
             return {
                name: `image-${index}.jpg`,
                url: url,
                status: 'success'
             };
          }
          return null;
        }).filter(item => item !== null);
      } else if (this.editData.imageUrlJson) {
        // 尝试解析imageUrlJson字段
        try {
          const imageUrls = JSON.parse(this.editData.imageUrlJson);
          if (Array.isArray(imageUrls) && imageUrls.length > 0) {
            this.form.imageList = imageUrls.map((url, index) => {
              if (typeof url === 'string' && url.length > 0) {
                return {
                  name: `image-${index}.jpg`,
                  url: url,
                  status: 'success'
                };
              }
              return null;
            }).filter(item => item !== null);
          }
        } catch (e) {
          console.error('解析imageUrlJson失败:', e);
        }
      }
    },
    handleClose() {
      if (this.isViewOnly) {
        this.dialogVisible = false;
        return;
      }

      this.$confirm('确定要关闭吗？未保存的数据将会丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dialogVisible = false;
      }).catch(() => {});
    },
    handlePreview(file) {
      this.previewImage = file.url;
      this.previewVisible = true;
    },
    handleRemove(file) {
      const index = this.form.imageList.indexOf(file);
      if (index !== -1) {
        this.form.imageList.splice(index, 1);
      }
    },
    handleChange(file, fileList) {
      this.form.imageList = fileList;
    },
    handleVideoChange(file) {
      this.form.videoFile = file.raw;
      this.form.videoUrl = URL.createObjectURL(file.raw);
      return true;
    },
    handleVideoRemove() {
      this.form.videoUrl = '';
      this.videoUploadPercent = 0;
    },
    handleFileChange(file, fileList) {
      this.form.fileList = fileList;
    },
    handleFileRemove(file) {
      const index = this.form.fileList.indexOf(file);
      if (index !== -1) {
        this.form.fileList.splice(index, 1);
      }
    },
    handleImageChange(file, fileList) {
      this.form.imageList = fileList.map(item => {
        if (item.raw && !item.url) {
          // 这是新添加的文件，为其创建预览URL
          return {
            ...item,
            url: URL.createObjectURL(item.raw),
            status: 'ready' // 标记为待上传
          };
        }
        return item;
      });
    },
    handleVideoUploadSuccess(response, file) {
      console.log("Video Success Response:", response);
      if (response && response.status === 200 && response.url) {
        this.form.videoUrl = response.url;
        this.videoUploadPercent = 100;
        this.$message.success('视频上传成功');
      } else {
        this.$message.error(`视频上传失败: ${response.message || '未知错误'}`);
        this.form.videoUrl = '';
        this.videoUploadPercent = 0;
      }
    },
    handleFileUploadSuccess(response, file, fileList) {
      if (response && response.status === 200) {
        file.url = response.url;
        this.form.fileList = fileList;
      } else {
        this.$message.error('文件上传失败');
      }
    },
    resetForm() {
      this.form = {
        id: '',
        name: '',
        roomNum: 1,
        hallNum: 1,
        kitchenNum: 1,
        toiletNum: 1,
        area: '',
        orientation: '南',
        floor: '',
        price: '',
        availableDate: new Date().toISOString().split('T')[0],
        location: '',
        rentType: '整租',
        rentPeriod: '长租',
        isWorryFree: false,
        highlightTags: [],
        normalTags: [],
        contactPhone: '',
        weChatWorkImage: '',
        imageList: [],
        videoUrl: '',
        status: '0',
        college: '',
      };
      this.videoUploadPercent = 0;
      this.normalTagInputVisible = false;
      this.normalTagInputValue = '';
      if (this.$refs.uploadForm) {
         this.$refs.uploadForm.resetFields();
      }
    },
    handleUpload() {
      this.$refs.uploadForm.validate(async (valid) => {
        if (valid) {
          try {
            const loading = this.$loading({
              lock: true,
              text: '正在上传，请稍候...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });

            // 上传所有文件到服务器
            try {
              // 上传图片
              const imagePromises = this.form.imageList
                .filter(file => file.status === 'ready' && file.raw)
                .map(file => this.uploadFileToServer(file.raw));

              // 上传视频
              let videoPromise = Promise.resolve(null);
              if (this.form.videoFile) {
                videoPromise = this.uploadFileToServer(this.form.videoFile);
              }

              // 上传微信二维码
              let weChatPromise = Promise.resolve(null);
              if (this.form.weChatWorkFile) {
                weChatPromise = this.uploadFileToServer(this.form.weChatWorkFile);
              }

              // 等待所有上传完成
              const [imageResults, videoResult, weChatResult] = await Promise.all([
                Promise.all(imagePromises),
                videoPromise,
                weChatPromise
              ]);

              // 更新图片URL列表
              for (let i = 0; i < imageResults.length; i++) {
                const result = imageResults[i];
                if (result && result.isSuccess && result.code === 200 && result.data && result.data.url) {
                  const fileIndex = this.form.imageList.findIndex(file => file.status === 'ready');
                  if (fileIndex !== -1) {
                    this.form.imageList[fileIndex].url = result.data.url;
                    this.form.imageList[fileIndex].status = 'success';
                  }
                } else {
                  throw new Error('图片上传失败');
                }
              }

              // 更新视频URL
              if (videoResult && videoResult.isSuccess && videoResult.code === 200 && videoResult.data && videoResult.data.url) {
                this.form.videoUrl = videoResult.data.url;
              } else if (this.form.videoFile) {
                throw new Error('视频上传失败');
              }

              // 更新微信二维码URL
              if (weChatResult && weChatResult.isSuccess && weChatResult.code === 200 && weChatResult.data && weChatResult.data.url) {
                this.form.weChatWorkImage = weChatResult.data.url;
              } else if (this.form.weChatWorkFile) {
                throw new Error('企微图片上传失败');
              }

            } catch (error) {
              loading.close();
              this.$message.error('文件上传失败，请重试');
              console.error('文件上传错误:', error);
              return;
            }

            const imageUrls = this.form.imageList.map(file => file.url).filter(url => url);
            const videoUrl = this.form.videoUrl;
            const fileUrls = (this.form.fileList || []).map(file => file.url).filter(url => url);

            const housePattern = `${this.form.roomNum}室${this.form.hallNum}厅${this.form.kitchenNum}厨${this.form.toiletNum}卫`;

            const rentHouse = {
              id: this.isEdit && this.form.id ? this.form.id : undefined,
              title: this.form.name,
              address: this.form.location,
              amount: parseFloat(this.form.price) || 0,
              type: this.form.rentType,
              college: this.form.college || '',
              floor: this.form.floor,
              housePattern: housePattern,
              orientation: this.form.orientation,
              leaseTerm: this.form.rentPeriod,
              proportion: this.form.area ? `${this.form.area}㎡` : '',
              phoneNumber: this.form.contactPhone,
              imageUrlJson: JSON.stringify(imageUrls || []),
              imageUrl: imageUrls || [],
              videoUrl: videoUrl,
              weChatWorkImage: this.form.weChatWorkImage,
              isLift: this.form.highlightTags.includes('isLift') ? true : false,
              isDomestic: this.form.highlightTags.includes('isDomestic') ? true : false,
              isPropertyFee: this.form.highlightTags.includes('isPropertyFee') ? true : false,
              isShortRent: this.form.highlightTags.includes('isShortRent') ? true : false,
              enableType: true,
              status: Number(this.form.status),
              browseNumbers: this.isEdit && this.originalData.browseNumbers !== undefined ? this.originalData.browseNumbers : 0,
              remark: this.isEdit && this.originalData.remark ? this.originalData.remark : ''
            };

            // 编辑模式下，使用原始日期格式
            if (this.isEdit) {
              // 保持所有时间相关字段的原始值
              if (this.originalData.checkTime) {
                rentHouse.checkTime = this.originalData.checkTime;
              }
              if (this.originalData.createdAt) {
                rentHouse.createdAt = this.originalData.createdAt;
              }
              if (this.originalData.updatedAt) {
                rentHouse.updatedAt = this.originalData.updatedAt;
              }
              if (this.originalData.deletedAt) {
                rentHouse.deletedAt = this.originalData.deletedAt;
              }
            } else {
              // 新建模式
              rentHouse.checkTime = this.formatDateTime(this.form.availableDate);
              rentHouse.createdAt = this.formatDateTime(new Date());
              rentHouse.updatedAt = null;
              rentHouse.deletedAt = null;
            }

            // 移除undefined值
            Object.keys(rentHouse).forEach(key => {
              if (rentHouse[key] === undefined) {
                delete rentHouse[key];
              }
            });

            const requestData = {
              ...rentHouse
            };

            const url = this.isEdit ? '/rentHouse/updateHouse' : '/rentHouse/insertHouse';
            const response = await postRed('post', url, requestData);

            loading.close();

            if (response.status === 200) {
              // 不显示成功提示，由父组件统一处理
              // this.$message.success(this.isEdit ? '房源编辑成功' : '房源上传成功');
              this.dialogVisible = false;
              this.$emit('submit-success', {
                ...rentHouse,
                id: response.data && response.data.data ? response.data.data.id : rentHouse.id
              });
            } else {
              this.$message.error((this.isEdit ? '编辑失败' : '上传失败') + '，请重试');
            }
          } catch (error) {
            console.error('上传错误:', error);
            this.$message.error('操作失败，请重试');
          }
        } else {
          this.$message.error('请填写完整信息');
          return false;
        }
      });
    },
    showNormalTagInput() {
      this.normalTagInputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.focus();
      });
    },
    handleNormalTagInputConfirm() {
      if (this.normalTagInputValue.trim() !== '') {
        this.form.normalTags.push(this.normalTagInputValue.trim());
      }
      this.normalTagInputVisible = false;
      this.normalTagInputValue = '';
    },
    handleNormalTagClose(tag) {
      this.form.normalTags = this.form.normalTags.filter(t => t !== tag);
    },
    handleWeChatWorkImageChange(file) {
      this.form.weChatWorkFile = file.raw;
      this.form.weChatWorkImage = URL.createObjectURL(file.raw);
      return true;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error('上传企微二维码图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传企微二维码图片大小不能超过 2MB!');
      }
      return (isJPG || isPNG) && isLt2M;
    },
    beforeVideoUpload(file) {
      const isMP4 = file.type === 'video/mp4';
      const isLt50M = file.size / 1024 / 1024 < 50;

      if (!isMP4) {
        this.$message.error('上传视频只能是 MP4 格式!');
      }
      if (!isLt50M) {
        this.$message.error('上传视频大小不能超过 50MB!');
      }
      return isMP4 && isLt50M;
    },
    handleVideoProgress(event, file) {
      this.videoUploadPercent = Math.round((event.loaded / event.total) * 100);
    },
    handleImageUploadSuccess(response, file, fileList) {
      console.log("Image Success Response:", response);
      if (response && response.status === 200 && response.url) {
        const index = fileList.findIndex(item => item.uid === file.uid);
        if (index !== -1) {
            fileList[index].url = response.url;
            fileList[index].status = 'success';
        }
         this.form.imageList = [...fileList];
      } else {
        this.$message.error(`图片 ${file.name} 上传失败: ${response.message || '未知错误'}`);
        this.form.imageList = fileList.filter(item => item.uid !== file.uid);
      }
    },
    handleWeChatWorkImageUploadSuccess(response, file) {
      console.log("WeChat Success Response:", response);
      if (response && response.status === 200 && response.url) {
        this.form.weChatWorkImage = response.url;
        this.$message.success('企微图片上传成功');
      } else {
        this.$message.error(`企微图片上传失败: ${response.message || '未知错误'}`);
        this.form.weChatWorkImage = '';
      }
    },
    clearWeChatWorkImage() {
      this.form.weChatWorkImage = '';
    },
    handleCustomUpload(options) {
      // 只存储文件信息，不立即上传
      const { file } = options;
      // 为文件创建本地预览URL
      const url = URL.createObjectURL(file);
      // 更新文件对象
      const updatedFile = {
        uid: file.uid,
        name: file.name,
        status: 'ready', // 设置状态为ready，表示还未上传
        url: url,
        raw: file // 保存原始文件对象，用于后续上传
      };

      // 更新文件列表
      const index = this.form.imageList.findIndex(item => item.uid === file.uid);
      if (index !== -1) {
        this.form.imageList[index] = updatedFile;
      } else {
        this.form.imageList.push(updatedFile);
      }
    },

    handleCustomVideoUpload(options) {
      // 只存储视频信息，不立即上传
      const { file } = options;
      // 为文件创建本地预览URL
      this.form.videoUrl = URL.createObjectURL(file);
      this.form.videoFile = file; // 保存原始文件对象，用于后续上传
    },

    handleCustomWeChatUpload(options) {
      // 只存储微信二维码信息，不立即上传
      const { file } = options;
      // 为文件创建本地预览URL
      this.form.weChatWorkImage = URL.createObjectURL(file);
      this.form.weChatWorkFile = file; // 保存原始文件对象，用于后续上传
    },

    // 将文件上传到服务器的方法
    async uploadFileToServer(file) {
      return new Promise((resolve, reject) => {
        // 创建FormData对象
        const formData = new FormData();
        formData.append('file', file);
        formData.append('token', this.uploadData.token);

        // 创建XMLHttpRequest
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/api/tool/ossUpload', true);

        // 设置headers
        for (const key in this.uploadHeaders) {
          if (Object.prototype.hasOwnProperty.call(this.uploadHeaders, key)) {
            xhr.setRequestHeader(key, this.uploadHeaders[key]);
          }
        }

        // 处理上传进度
        xhr.upload.addEventListener('progress', event => {
          if (event.lengthComputable) {
            const percent = Math.round((event.loaded / event.total) * 100);
            if (file === this.form.videoFile) {
              this.videoUploadPercent = percent;
            }
          }
        });

        // 处理请求完成
        xhr.addEventListener('load', () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            try {
              const response = JSON.parse(xhr.responseText);
              resolve(response);
            } catch (error) {
              reject(new Error('无法解析响应'));
            }
          } else {
            reject(new Error('上传失败'));
          }
        });

        // 处理错误
        xhr.addEventListener('error', () => {
          reject(new Error('网络错误'));
        });

        // 发送请求
        xhr.send(formData);
      });
    },
    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
    },
    formatDateTime(dateStr) {
      const date = new Date(dateStr);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
    },
  }
}
</script>

<style scoped>
.house-upload-container {
  font-size: 14px;
}

.upload-form {
  max-height: 500px;
  overflow-y: auto;
  padding: 0 10px;
}

.house-type-inputs {
  display: flex;
  align-items: center;
}

.type-label {
  margin: 0 10px 0 5px;
}

.upload-box {
  margin-bottom: 10px;
}

.upload-tip {
  color: #909399;
  font-size: 12px;
  margin-top: 10px;
}

.form-actions {
  text-align: right;
  margin-top: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
}

.upload-text {
  margin-top: 10px;
  color: #8c939d;
}

.upload-progress {
  margin-top: 10px;
}

.upload-tip-small {
  color: #909399;
  font-size: 12px;
  margin-top: 10px;
}

.readonly-images {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.image-item {
  width: 148px;
  height: 148px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
}

.image-item:hover {
  border-color: #409EFF;
  transform: scale(1.02);
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.readonly-image-container, .readonly-video-container {
  width: 178px;
  height: 178px;
  border-radius: 6px;
  overflow: hidden;
}

.readonly-image-container img, .readonly-video-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-image-placeholder {
  width: 100%;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #909399;
}

.no-image-placeholder i {
  font-size: 42px;
  margin-bottom: 10px;
}

.no-image-placeholder p {
  font-size: 14px;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/rentalSystem/houseUpload.vue